import { render, staticRenderFns } from "./tablaSucursales.vue?vue&type=template&id=37fdc940&"
import script from "./tablaSucursales.vue?vue&type=script&lang=js&"
export * from "./tablaSucursales.vue?vue&type=script&lang=js&"
import style0 from "./tablaSucursales.vue?vue&type=style&index=0&id=37fdc940&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports